import script from "./SetCode.vue?vue&type=script&setup=true&lang=js"
export * from "./SetCode.vue?vue&type=script&setup=true&lang=js"

import "./SetCode.vue?vue&type=style&index=0&id=acbcda4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acbcda4c"]])

export default __exports__